import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, Output, QueryList, TemplateRef, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { environment } from '@environments/environment';
import { tipoMapaEnum, zoomControlEnum, tipoEfectoMarcadorEnum, IEstilosPropiedadConfig, DEMO_DIRECCIONES, DEMO_ESTILOS } from './datos-estaticos-demo-mapa';


@Component({
  selector: 'neo-mapa',
  templateUrl: './mapa.component.html',
  styleUrls: ['./mapa.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapaComponent {
  // Configuración
  @Input() zoom = 13;
  @Input() cambiarEscalaBotones = true;
  @Input() cambiarEscalaScroll = false;
  @Input() mostrarStreetView = false;
  @Input() seleccionarMapa = false;
  @Input() arrastrar = true;
  @Input() tipoMapaDefecto = tipoMapaEnum.MAPA_TIPO_CALLEJERO;
  @Input() mapasSeleccionables = [tipoMapaEnum.MAPA_TIPO_COMBINADO, tipoMapaEnum.MAPA_TIPO_CALLEJERO, tipoMapaEnum.MAPA_TIPO_SATELITE, tipoMapaEnum.MAPA_TIPO_TERRENO];
  @Input() mostrarLugares = false;
  @Input() controlTeclado = true;
  @Input() https = true;
  @Input() cargaAsincrona = false;
  @Input() identificadorMapa = 0;
  @Input() zoomControl = zoomControlEnum.SMALL;
  @Input() codigoIdioma = 'es/ES';
  @Input() clave_matrix_mapaApikeyServidor = '';

  // Marcador
  @Input() markerTitle;
  @Input() iconoMarker = 'map-marker.svg';
  @Input() efectoCaida = tipoEfectoMarcadorEnum.MAPA_MARCADOR_EFECTO_CAIDA;
  // La acción por defecto en matrix está desactivada por las excesivas llamadas a la api
  @Input() accionDefectoMarker = false;

  // Estilos
  @Input() estilos: IEstilosPropiedadConfig [] = [];
  // @Input() estilos: IEstilosPropiedadConfig [] = DEMO_ESTILOS;

  
  // Únicamente aplicaría cuando no tenemos las coordenadas, únicamente la dirección o se quieren renderizar varios mapas
  @Input() direcciones = [];
  // @Input() direcciones = DEMO_DIRECCIONES;


  latitud;
  longitud;
  apiKey = this.preferenciasService.get('matrix_mapaApikeyServidor') ? this.preferenciasService.get('matrix_mapaApikeyServidor') : this.clave_matrix_mapaApikeyServidor;
 

  @ViewChildren('mapRef') referenciaMapas: QueryList<ElementRef>;


  constructor(
    private http: HttpClient,
    private preferenciasService: PreferenciasService,
    private helpersService: HelpersService,
    private edicionSeccionesService: EdicionSeccionesService,
  ) {
    if (this.helpersService.hayModulo('edicion')) {
      this.edicionSeccionesService.getContenidoBloquesSubseccion('contacto-hq').subscribe(data => {
          data.elementos.forEach((elemento, index) => {
            let indice = (data.multiple) ? index : -1;
            this.latitud = Number(this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-dir-lat', indice));
            this.longitud = Number(this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-dir-lon', indice));
            this.iniciarPagina();
          })
      })
    } else {
      this.latitud = this.preferenciasService.get('matrix_mapaLatitudDefecto');
      this.longitud = this.preferenciasService.get('matrix_mapaLongitudDefecto');
      this.iniciarPagina();
    }

  }


  iniciarPagina() {
    setTimeout(() => {
      this.inicializarMapa();
    })
  }

  inicializarMapa() {
    let scriptScr;
    this.apiKey ? scriptScr = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=initMap` : scriptScr = 'https://maps.googleapis.com/maps/api/js?key=&callback=initMap';
    if(!window.document.getElementById('google-map-script')) {
      var s = window.document.createElement("script");
      s.id = "google-map-script";
      s.type = "text/javascript";
      s.src = scriptScr;
      window.document.body.appendChild(s);
    } 

    if (!window['initMap']) {
      window['initMap'] = () => {
       this.cargarMapa();
      }
    } else {
      this.cargarMapa();
    }
  }

  cargarMapa() {
    if (this.latitud && this.longitud)  {
      this.obtenerDireccion();
      this.cargarMapaCoordenadas()
    } else if (this.direcciones) {
      this.cargarMapaDirecciones();
    } 
  }

  cargarMapaCoordenadas () {
    if (this.latitud && this.longitud) {
      if (window['google']) {
        var mapa = new window['google'].maps.Map(this.referenciaMapas['_results'][this.identificadorMapa].nativeElement, {
          center: {lat: this.latitud, lng: this.longitud},
          disableMapTypeControl: !this.seleccionarMapa,
          streetViewControl: this.mostrarStreetView,
          disableDefaultUI:  this.cambiarEscalaBotones,
          map_div_id: "mapadegoogle" + this.identificadorMapa,
          map_height: '100%',
          map_width: '100%',
          map_name: 'mapa' + this.identificadorMapa, //no se usa, sería para referencias desde el js
          map_type : this.tipoMapaDefecto, // HYBRID, ROADMAP, SATELLITE, TERRAIN, STREET
          map_types_avaliable: this.mapasSeleccionables, //"HYBRID", "ROADMAP","SATELLITE", "TERRAIN"
          mapTypeControlPosition: "TOP", //?BOTTOM?, ?BOTTOM_LEFT?,?BOTTOM_RIGHT?, ?LEFT?,?RIGHT?, ?TOP?, ?TOP_LEFT?,?TOP_RIGHT?
          places: this.mostrarLugares,
          zoom: this.zoom,
          zoomControlStyle: this.zoomControl, //SMALL, LARGE
          scrollwheel: this.cambiarEscalaScroll,
          disableDoubleClickZoom: this.cambiarEscalaScroll,
          keyboardShortcuts: this.controlTeclado,
          draggable: this.arrastrar,
          https: this.https,
          loadAsynchronously: this.cargaAsincrona,
          language: this.codigoIdioma,
        });
  
        this.cargarEstilosMapa(mapa);
  
        var marker = new window['google'].maps.Marker({
          position: {lat: this.latitud, lng: this.longitud},
          map: mapa,
          title: this.markerTitle,
          draggable: false,
          animation: window['google'].maps.Animation[this.efectoCaida],
          icon: `${environment.base_url}${environment.ruta_images}iconos/${this.iconoMarker}`,
        });
  
        if (this.accionDefectoMarker) this.cargarAccionDefectoMarker(marker, mapa);
      }
     
    }
  }



  cargarMapaDirecciones() {
    if (this.direcciones.length > 0) {
      this.direcciones.forEach(direccion => {
        if (direccion['iconoMarker'])  this.iconoMarker = direccion['iconoMarker'];
        if (direccion['efectoCaida'])  this.efectoCaida = direccion['efectoCaida'];
        this.definirCoordenadasDireccion(direccion.direccion, true);
      });
    }
  }
  

cargarEstilosMapa(mapa) {
  if (this.estilos.length > 0) {
    let estilosMap = [];

    this.estilos.forEach(estilo => {
      let estiloMap = {};
      let arrayEstilos = [];
      if(estilo.visible) arrayEstilos.push({visibility: estilo['visible']});
      if(estilo.color) arrayEstilos.push({color: estilo['color']});
      if(estilo.gamma) arrayEstilos.push({gamma: estilo['gamma']});
      if(estilo.matiz) arrayEstilos.push({hue: estilo['matiz']});
      if(estilo.brillo) arrayEstilos.push({lightness: estilo['brillo']});
      if(estilo.invertirBrillo) arrayEstilos.push({invert_lightness: estilo['invertirBrillo']});
      if(estilo.saturacion) arrayEstilos.push({saturation: estilo['saturacion']});
      if(estilo.grosor) arrayEstilos.push({weight: estilo['grosor']});
      estiloMap = {featureType: estilo.elemento, elementType: estilo.tipo, stylers: arrayEstilos}
      estilosMap.push(estiloMap);
    })

    const styledMapType = new window['google'].maps.StyledMapType(
      estilosMap,
       { name: "Custom map" }
     );
     mapa.mapTypes.set("styled_map", styledMapType);
     mapa.setMapTypeId("styled_map");  
   }
}
    

cargarAccionDefectoMarker(marker, mapa) {
  const contentString =
  '<h1>Dirección</h1>';

  const infowindow = new window['google'].maps.InfoWindow({
    content: contentString,
  });

  marker.addListener("click", () => {
    infowindow.open({
      anchor: marker,
      mapa,
      shouldFocus: false,
    });
  });  
}

obtenerDireccion() {
  if (this.latitud && this.longitud) { 
      this.http.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.latitud},${this.longitud}&sensor=false&key=${this.apiKey}`)
      .subscribe(data => {
        this.direcciones = data['results'][0]?.formatted_address;
      });
  } 
}

definirCoordenadasDireccion(direccion, cargarMapaCoordenadas = false): void {
  if (direccion) {
    this.http.get(`https://maps.googleapis.com/maps/api/geocode/json?sensor=false&address=${direccion}&key=${this.apiKey}`)
    .subscribe(data => {
      
      if (data['results'].length > 0) {
        this.latitud = data['results'][0].geometry.location.lat;
        this.longitud = data['results'][0].geometry.location.lng;
        if (cargarMapaCoordenadas) {
          this.cargarMapaCoordenadas();
        }
      }
    });
  } 
}
}
